import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {NumericTextBoxComponent} from "@syncfusion/ej2-vue-inputs";
import {ref, computed} from "vue";

interface Props {
  placeholder?: string,
  modelValue?: number,
  format?: string
  name?: string
  min?: number | string
  max?: number | string
  step?: number | string
  width?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogNumericTextBox',
  props: {
    placeholder: { default: undefined },
    modelValue: { default: undefined },
    format: { default: undefined },
    name: { default: undefined },
    min: { default: undefined },
    max: { default: undefined },
    step: { default: undefined },
    width: { default: "160px" }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = __emit
const input = ref<InstanceType<typeof NumericTextBoxComponent> | null>(null)

const _style = computed<string>(() => props.width ? "width: " + props.width : "")
const focus = () => {
  input.value?.focusIn();
}

__expose({
  focus
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_style.value)
  }, [
    _createVNode(_unref(NumericTextBoxComponent), {
      ref_key: "input",
      ref: input,
      value: __props.modelValue,
      "float-label-type": "Always",
      placeholder: __props.placeholder,
      format: __props.format,
      name: __props.name,
      step: __props.step,
      min: __props.min,
      max: __props.max,
      locale: "de",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.value)))
    }, null, 8, ["value", "placeholder", "format", "name", "step", "min", "max"])
  ], 4))
}
}

})